import React from "react"
import {connect} from "react-redux"

import {colors} from "../../utils/styles"

let moment
import(/* webpackChunkName: "momentTimezone" */ "moment-timezone").then(module => moment = module.default)

export class MaintenancePage extends React.Component {

  render() {
    const format = "dddd MM/DD/YYYY hh:mm A z"
    let maintDates
    const now = moment()
    const props = this.props
    if (now.isBetween(props.startMoment, props.endMoment)) {
      maintDates = props.startMoment.tz("America/New_york").format(format) + " - "
          + props.endMoment.tz("America/New_york").format(format)
    }
    const userProfile = props.userProfile
    if (!userProfile) {
      return null
    }
    const truckIcon = userProfile.forCosco ? "images/cosco/maintenanceLogo.svg" : "images/oocl/maintenanceLogo.svg"
    return (
        <div id="todo-list"
             style={{width: '100%', height: '100VH', display: 'flex', flexDirection: 'column'}}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: colors.grayDark
          }}>
            <div style={{paddingTop: 150}}>
              <img alt="System Maintenance" src={truckIcon}/>
            </div>
            <div style={{paddingTop: 50, fontSize: 36}}>We’re undergoing a scheduled maintenance.</div>
            <div style={{paddingTop: 10, fontSize: 21}}>Sorry for the inconvenience. Please check back soon.
            </div>
            <div style={{paddingTop: 50, fontSize: 30, fontWeight: 'bold'}}>{maintDates}</div>
          </div>
        </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    startMoment: state.app.startMoment,
    endMoment: state.app.endMoment,
    userProfile: state.userProfile
  }
}

export default connect(mapStateToProps)(MaintenancePage)